module.exports = "<p>Add collector template</p> ";


//////////////////
// WEBPACK FOOTER
// ./components/collector/add/add-collector.template.html
// module id = ./components/collector/add/add-collector.template.html
// module chunks = 0